import { RemoteCreatePartner } from 'data/usecases/partners';
import { makeApiUrlPartners } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteCreatePartner = (): RemoteCreatePartner => {
  return new RemoteCreatePartner(
    makeApiUrlPartners(),
    makeAxiosHttpClient(),
  );
};
